// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2hrS5","signatureButtonsRight":"ModalSign_signatureButtonsRight__pL10m"};